<div>
  <div>
    <span *ngIf="label != null && !hideLabel" [class.color--danger]="hasErrors">
      {{ uppercaseLabel ? (label | uppercase) : label }}
    </span>

    <span *ngIf="tooltipMsg != null">
      <ta-icon icon="help-circled" [taTooltipStatic]="tooltipMsg"> </ta-icon>
    </span>
  </div>

  <span
    *ngIf="description != null && !hideDescription"
    [class.color--danger]="hasErrors"
  >
    {{ description }}
  </span>
</div>

<div><ng-content></ng-content></div>

<ng-container *ngIf="showErrors">
  <ta-form-errors-list [label]="label" [errors]="errorsMap">
  </ta-form-errors-list>
</ng-container>
